<div class="d-flex" id="wrapper">
    <admin-sidebar id="admin-sidebar"></admin-sidebar>
    <div id="page-content-wrapper">
      <admin-navigation></admin-navigation>
      <div class="container-fluid">
        <div class="mt-5 mt-md-5 mb-3 mb-md-3">
          <h3 class="font-weight-bold page-title">7-Day Challenge Results</h3>
        </div>
        <div>
        <div class="row mb-4 mb-md-4">
          <div class="col-md-4 pl-3 pl-md-3">
            <!--
            <input type="text" class="form-control" placeholder="Search Enterprise" #searchEnterprise>
            -->
            <select class="form-control" (change)="changeOrg()" [(ngModel)]="organisationVal">
              <option value="{{org.key}}" *ngFor="let org of organisations">{{org.value}}</option>
            </select>
          </div>
          <div class="col-md-4 pl-3 pl-md-3">
            <!--
            <input type="text" class="form-control" placeholder="Search Voucher code" #searchVoucher>
            -->
            <select class="form-control" (change)="changeVoucher()" [(ngModel)]="voucherVal">
              <option value="{{voucher.key}}" *ngFor="let voucher of vouchers">{{voucher.value}}</option>
            </select>
          </div>
          <div class="col-md-4 pl-3 pl-md-3">
            <input type="text" class="form-control" placeholder="Search Name or Email" #searchNameOrEmail>
          </div>
        </div>

        <div class="row mb-4 mb-md-4">

          <div class="form-group col-md-2">
            <div class="input-group">
              <input
                class="form-control"
                placeholder="Date from"
                name="fromDate"
                ngbDatepicker
                (click)="d.toggle()"
                (dateSelect)="onDateFromSelection($event)"
                #d="ngbDatepicker"
                id="dateInputFrom"
                [(ngModel)]="dpFromDate"
                readonly
              >
              <div class="input-group-append clear-date">
                <span class="input-group-text" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
              </div>
            </div>
          </div>

          <div class="form-group col-md-2">
            <div class="input-group">
              <input
                class="form-control"
                placeholder="Date to"
                name="toDate"
                ngbDatepicker
                (click)="f.toggle()"
                (dateSelect)="onDateToSelection($event)"
                #f="ngbDatepicker"
                id="dateInputTo"
                [(ngModel)]="dpToDate"
                readonly
              >
              <div class="input-group-append clear-date">
                <span class="input-group-text" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
              </div>
            </div>
          </div>

        </div>

        <div class="mb-4 mb-md-4">
          <p class="font-weight-bold mb-0">Summary</p>
          <p>Total users completed the 7-day challenge: {{ users.users_completed_percentage }}% ({{ users.users_completed }}/{{ users.total_users }})</p>
          <p class="font-weight-bold mb-0">Improvements</p>
          <p class="mb-0">Question 1 - {{ users.improved_question_1 }}%</p>
          <p class="mb-0">Question 2 - {{ users.improved_question_2 }}%</p>
          <p class="mb-0">Question 3 - {{ users.improved_question_3 }}%</p>
        </div>
        
        <div class="row">
          <div class="col-md-12">
            <h5>Total: {{ usersTotal }}</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 table-responsive">
            <table class="table table-borderless">
              <colgroup>
                <col width="20%">
                <col width="20%">
                <col width="15%">
                <col width="15%">
                <col width="15%">
                <col width="15%">
              </colgroup>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-center">Challenge complete date</th>
                  <th class="text-center">% Improvement for Question 1</th>
                  <th class="text-center">% Improvement for Question 2</th>
                  <th class="text-center">% Improvement for Question 3</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of users.users">
                  <td>{{ user.first_name }} {{ user.last_name }}</td>
                  <td>{{ user.email }}</td>
                  <td class="text-center">{{ user.submitted_on * 1000 | date: 'dd LLL yyyy' : '+1200' }}</td>
                  <td class="text-center">{{ user.question_1 }}</td>
                  <td class="text-center">{{ user.question_2 }}</td>
                  <td class="text-center">{{ user.question_3 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <nav *ngIf="usersTotal > 25" >
          <ul class="pagination justify-content-center">
            <li
              class="page-item"
              [ngClass]="{'disabled': currentPage == 1}"
              (click)="paginate(currentPage - 1)"
            >
              <a class="page-link" tabindex="-1">Previous</a>
            </li>
            <li
              class="page-item"
              *ngFor="let link of pageLinks"
              [ngClass]="{'active': currentPage == link}"
              (click)="paginate(link)"
            >
              <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
            </li>
            <li
              class="page-item"
              [ngClass]="{'disabled': currentPage == lastPage}"
              (click)="paginate(currentPage + 1)"
            >
              <a class="page-link">Next</a>
            </li>
          </ul>
        </nav>
        <!-- End of Pagination -->

      </div>
</div>

<!-- Modal Loader -->
<modal-loader [modalText]="modalText"></modal-loader>